export const locale = {
  lang: 'nl',
  data: {
    'CONFIRMACION': {
      'FELICI': 'GEFELICITEERD, JE HEBT HET EINDE VAN HET CONFIGURATIEPROCES BEREIKT!',
      'INDICACION': 'Om uw enquête actief en klaar voor toepassing op de geconfigureerde data te laten zijn, moet u op de knop Enquête activeren klikken',
      'CONFIRMAR': 'Activeer onderzoek',
      'IND_CONFIRM_JP': 'Alvorens verder te gaan met de activering van de enquête is het noodzakelijk de eerder geconfigureerde informatie te bevestigen.',
      'BTN_CONFIRM_INFO': 'Bevestig informatie ',
      'IND_ESP_CONFIRM_JP':'Zodra de projectmanager bevestigt, gaan we over tot het activeren van de enquête.',
      'MOD_TIT_CONGR_CONF':'Bedankt voor uw bevestiging',
      'MOD_ESP_CONFIRM_JP':'We hebben alleen de goedkeuring van de projectmanager nodig om door te gaan met het activeren van de enquête.',
      'CERRAR-CONFIRMAR': 'Deactiveer de enquête',
      'MESSAGE5': 'Actief onderzoek klaar om te worden toegepast',
      'HISTORY_ACTIVATION_1': 'Laatste activering/deactivering',
      'HISTORY_ACTIVATION_2': 'Activeringsgeschiedenis:',
      'ESTATUS_SURVEY':{
      '0': 'Desactivering',
      '1': 'Activering',
      '2': 'Gesloten',
      },
      'BOTONES-MODALES':{
        'ELIMINAR':{
          // 'MESSAGE1':'<span>To continue the activation of the survey',
          // 'MESSAGE2':', enter the text in red in the text box</span>',
          'MESSAGE1':'<span> Om de activering van de enquête voort te zetten, voert u de tekst in het tekstvak in het rood in: ',
          'MESSAGE2': '</span>',
          'SALIR': 'Annuleren',
          'VALIDAR': 'Bevestigen',
          'ERRORNOMBREEMPRESA': 'de ingevoerde tekst komt niet overeen met de in het rood aangegeven tekst',
          'SUCCES': 'De enquête werd geactiveerd',
          'CERRAR': 'Sluiten',
          'SUCCES-DES': 'Het onderzoek werd gedeactiveerd',
          'MESSAGE3':'<span> Om de enquête verder te deactiveren, voert u de tekst in het tekstvak in het rood in: ',
          'MESSAGE4': '</span>',
          'MESSAGE5': 'Op dit moment heeft de enquête al resultaten, weet u zeker dat u deze kunt deactiveren?',
          'MESSAGE6': 'Momenteel is er geen enquête',
          'BTN-ACEPTAR': 'Accepteren',
          'BTN-CANCELAR': 'Annuleren',
          'BTN-OK': 'Oké',
          'HORAMINIMA': 'De communicatie per e-mail kon niet worden bevestigd, de datum van de eerste te verzenden e-mail (lancering of eerste melding, afhankelijk van het geval) moet later zijn dan twee uur vanaf dit moment \n\nStel indien nodig de datums opnieuw in'
        },
        },
  },
  }
};
